import * as _CommunicationRules from './communication';
export { _CommunicationRules as CommunicationRules };
import * as _WhatsappBusinessRules from './whatsapp';
export { _WhatsappBusinessRules as WhatsappBusinessRules };
//# sourceMappingURL=index.js.map